"use client";
import { HTMLProps } from "react";
import Icon from "./icon";

type LogoutProps = {
  classname?: HTMLProps<HTMLElement>["className"];
};
export const LogoutButton = (props: LogoutProps) => {
  return (
    <div className={props.classname}>
      <a href="/logga-ut"
        className="btn-small bg-transparent border-sand-700 border-[3px] hover:bg-sand-700 pl-1.5 pr-3"
      >
        <Icon.Logout className="fill-gray-500 h-5 mr-2" />
        Logga ut
      </a>
    </div>
  );
};
